import React, { useState, useEffect } from "react";
import Header from "../../../components/Header/Header";
import LeftSideBar from "../../../components/LeftSideBar/LeftSideBar";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Box, Grid, IconButton, TablePagination } from "@mui/material";
import * as acts from "../../../redux/administrator/actions";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import CustomizedSnackbars from "../../../components/Snackbars/CustomizedSnackbars";
import "./reviewbatch.scss";
import DashboardTableSkaleton from "../../../components/Skeletons/DashboardTableSkaleton";
import TableReviewBatch from "../../../components/Table/TableReviewBatch";
import { adminRoutes } from "../../../routes/routeConstants";

function ReviewBatchRecords(props) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const batchRecord = useSelector((state) => state.admin.batchRecord);
  const [records, setRecords] = useState([]);
  const [page, setPage] = useState(0);
  const [pageCount, setPageCount] = useState(batchRecord?.total_count || 0);
  const [rowsPerPage, setRowsPerPage] = useState(100);
  const apiStatus = useSelector((state) => state?.admin?.apiStatus);
  const [message, setMessage] = useState("");
  const [err, setErr] = useState(false);
  const [success, setSuccess] = useState(false);
  // const [status, setStatus] = useState("");
  const handleDeletePdf = useSelector((state) => state?.admin?.handleDeletePdf);
  useEffect(() => {
    dispatch(acts.handleClearPDFDeleteData());
    dispatch(
      acts.getBatchRecordList({
        page: page + 1,
        page_size: rowsPerPage,
      })
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, page, rowsPerPage]);
  useEffect(() => {
    if (batchRecord?.data?.length > 0) {
      setRecords(batchRecord?.data);
    }
    setPageCount(batchRecord?.total_count);
  }, [batchRecord?.data, batchRecord?.total_count]);

  useEffect(() => {
    if (apiStatus && apiStatus !== undefined) {
      if (apiStatus?.message !== null && apiStatus?.next === false) {
        if (apiStatus?.message !== null && apiStatus?.next === false) {
          if (apiStatus?.message === "Invalid Token") {
            setMessage(apiStatus?.message);
            setErr(true);
          }
        }
      }
    }
  }, [apiStatus]);

  useEffect(() => {
    if (handleDeletePdf && handleDeletePdf !== undefined) {
      if (
        handleDeletePdf?.notification === true &&
        handleDeletePdf.apiSuccess === true &&
        handleDeletePdf?.loader === false
      ) {
        dispatch(acts.handleClearPDFDeleteData);
        setMessage(handleDeletePdf?.message);
        setSuccess(true);
        dispatch(
          acts.getBatchRecordList({
            page: page + 1,
            page_size: rowsPerPage,
          })
        );
      }

      dispatch(acts.handleClearPDFDeleteData);
    }
  }, [handleDeletePdf]);

  useEffect(() => {
    // Create WebSocket connection
    // const newSocket = new WebSocket(
    //   "wss://dev-api.cpvnxg.aventior.com/ws/upload-client-data-status/?token_header=8f3eb69be0e164b97b26c61b77e92c3afbbfa37c"
    // );
    const baseURL = process.env.REACT_APP_APIBASE_WS;
    const newSocket = new WebSocket(
      `${baseURL}/upload-client-data-status/?token_header=${localStorage.getItem(
        "token"
      )}`
    );

    newSocket.onopen = () => {
    };
    newSocket.onmessage = (event) => {
      let data = JSON.parse(event.data);
      const completion = data?.payload?.Completion;

      const completionID = data?.payload?.client_data_file_id;
      if (records.length > 0 && completionID) {
        const indexToUpdate = records.findIndex(
          (item) => item.client_data_file_id === completionID
        );
        if (indexToUpdate !== -1) {
          const updatedRecords = records;

          updatedRecords[indexToUpdate].completion_status = completion;

          setRecords([...updatedRecords]);
        } else {
          console.error(
            `Item with client_data_file_id ${completionID} not found in the list.`
          );
        }
      }
      // console.log(completion, "completion");
      // Handle WebSocket messages here
    };
    newSocket.onerror = (error) => {
      console.error("WebSocket error (WebSocket): ", error);
      // Handle WebSocket errors here
    };
    return () => {
      // newSocket.close();
      // fetchDataSocket.close();
    };
  }, [records]);

  const handleBack = () => {
    // navigate("/list-directory");
    navigate(`/${adminRoutes.listDirectory}`)
  };

  const handlePageChange = (event, value) => {
    setPage(value);
    dispatch(
      acts.getBatchRecordList({
        page: value + 1,
        page_size: rowsPerPage,
      })
    );
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(event.target.value);
    setPage(0);
  };

  // const handleRefresh = () => {
  //   dispatch(acts.handleClearPDFDeleteData());
  //   dispatch(
  //     acts.getBatchRecordList({
  //       page: page + 1,
  //       page_size: rowsPerPage,
  //     })
  //   );
  // };

  return (
    <>
      <Header />
      <Box>
        <Grid className="sidebar-main" container>
          <Grid item className="sidebar-container">
            <LeftSideBar page="sidebar" />
          </Grid>
          <Grid item className="visualization-conatiner reviewbatch-main-grid">
            <Box className="reviewbatch-main-box">
              <IconButton onClick={handleBack}>
                <ArrowBackIcon />
              </IconButton>
              <p className="heading">Upload Status</p>
            </Box>
            <Box className="reviewbatch-table-box">
              {apiStatus?.loader ? (
                <DashboardTableSkaleton />
              ) : (
                <TableReviewBatch
                  data={records}
                  // refresh={handleRefresh}
                  // Type="Batch"
                  // batchStatus={status}
                  // showDPCalculationMenu={true}
                />
              )}
            </Box>
            <Grid className="pagination-wrap">
              <TablePagination
                component="div"
                rowsPerPageOptions={[100, 200, 300, 500]}
                count={parseInt(pageCount)}
                page={parseInt(page)}
                onPageChange={handlePageChange}
                rowsPerPage={parseInt(rowsPerPage)}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </Grid>

            {success && (
              <CustomizedSnackbars
                severity="success"
                state={success}
                text={message}
                handleClose={() => setSuccess(false)}
              />
            )}

            {err && (
              <CustomizedSnackbars
                severity="error"
                state={err}
                text={message}
                handleClose={() => setErr(false)}
              />
            )}
          </Grid>
        </Grid>
      </Box>
    </>
  );
}

export default ReviewBatchRecords;
